import Button from '@ingka/button';
import Text from '@ingka/text';
import { useTranslation } from 'react-i18next';

import { PREFIX } from '../../../Skapa/constants/constants';

import styles from './MaintenanceMode.module.scss';

export const MaintenanceMode = ({ dismiss }: { dismiss: () => void }) => {
  const { t } = useTranslation('profile');

  return (
    <div className={styles.maintenanceContainer}>
      <Text prefix={PREFIX} textStyle="Heading.XL">
        {t('sheet.logIn.maintenance.heading')}
      </Text>
      <Text prefix={PREFIX} tagName="p" textStyle="Body.M">
        {t('sheet.logIn.maintenance.body')}
      </Text>
      <Button
        prefix={PREFIX}
        data-testid="maintenanceBtn"
        text={t('sheet.logIn.maintenance.buttonLabel')}
        type="primary"
        className={styles.maintenanceBtn}
        size="small"
        onClick={dismiss}
      />
      <div>
        <img src="https://asset.inter.ikea.com/images/PH179710_preview?v=0b8954a1" alt="" />
      </div>
    </div>
  );
};
